import { useEffect, useState } from 'react'

interface GeolocationResponse {
  country: string
}

export function useUserCountry(): {
  country: string | null
  isLoading: boolean
  error: string | null
} {
  const [country, setCountry] = useState<string | null>(null)
  const [isLoading, setIsLoading] = useState(true)
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    const fetchCountry = async () => {
      const cachedCountry = sessionStorage.getItem('user_country')
      if (cachedCountry) {
        setCountry(cachedCountry)
        setIsLoading(false)
        return
      }

      try {
        const response = await fetch('https://get.geojs.io/v1/ip/country.json')
        if (!response.ok) {
          throw new Error('Failed to fetch geolocation data')
        }
        const data: GeolocationResponse = await response.json()
        if (data.country) {
          setCountry(data.country)
          sessionStorage.setItem('user_country', data.country)
        } else {
          throw new Error('Country not found in response')
        }
      } catch (err) {
        const errorMessage = err instanceof Error ? err.message : 'An unknown error occurred'
        setError(errorMessage)
        console.error('User country fetch error:', errorMessage)
      } finally {
        setIsLoading(false)
      }
    }

    fetchCountry()
  }, [])

  return { country, isLoading, error }
}
